module.exports = __webpack_public_path__ + "images/views-upsell/calendar.fde7d53f0f2ededb3b57.svg";